import * as React from 'react'
import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import CircularProgress from '@mui/material/CircularProgress'

export default function SkeletonTable() {
  return (
    <Box sx={{ width: 1200, height: 450 }}>
      <CircularProgress />
      <Skeleton sx={{ height: 100 }} />
      <Skeleton sx={{ height: 50 }} animation="wave" />
      <Skeleton sx={{ height: 50 }} animation="wave" />
      <Skeleton sx={{ height: 50 }} animation="wave" />
      <Skeleton sx={{ height: 50 }} animation="wave" />
      <Skeleton sx={{ height: 50 }} animation="wave" />
      <Skeleton sx={{ height: 50 }} animation="wave" />
    </Box>
  )
}
